import { useEffect } from "react";
import { useNurseAssignmentsDebugQuery } from "@/hooks/roster-craete/useNurseAssignmentsDebugQuery";

type UseNurseAssignmentsDebugLoggerParams = {
  groupId: string | null;
};

export function useNurseAssignmentsDebugLogger({
  groupId,
}: UseNurseAssignmentsDebugLoggerParams) {
  const nurseAssignmentsDebugQuery = useNurseAssignmentsDebugQuery({
    groupId,
    enabled: true,
  });

  useEffect(() => {
    if (nurseAssignmentsDebugQuery.data) {
      console.log("[nurse_assignment][debug]", {
        groupId,
        data: nurseAssignmentsDebugQuery.data,
      });
    }
  }, [nurseAssignmentsDebugQuery.data, groupId]);

  useEffect(() => {
    if (nurseAssignmentsDebugQuery.error) {
      console.error("[nurse_assignment][debug][error]", {
        groupId,
        error: nurseAssignmentsDebugQuery.error,
      });
    }
  }, [nurseAssignmentsDebugQuery.error, groupId]);
}
